import React, { useMemo } from 'react';

interface ProfileBioProps {
  bio: string | null;
}

const ProfileBio = ({ bio }: ProfileBioProps) => {
  const text = bio || 'No bio yet';
  const len = text.length;
  // Scale font size based on length to avoid pushing header elements off screen
  const sizeClass = useMemo(() => {
    if (len > 600) return 'text-xs md:text-sm';
    if (len > 400) return 'text-sm md:text-base';
    if (len > 260) return 'text-[15px] md:text-[17px]';
    return 'text-base md:text-lg';
  }, [len]);

  return (
    <p className={`${sizeClass} text-foreground/80 my-4 leading-relaxed max-w-3xl mx-auto text-center`}> 
      {text}
    </p>
  );
};

export default ProfileBio;